import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Position } from '../../services/org-board-builder.service';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { ECONode, OrgSecurityGroup } from '@newgenus/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MaterialModule } from '../../../material.module';
import { NgFor, TitleCasePipe } from '@angular/common';
import { NormalizePipe } from '../../format-pipe';
import { ProfileColorService } from '../../services/profile-color.service';

@Component({
    selector: 'shared-org-hat-dialog',
    imports: [MaterialModule, NgFor, TitleCasePipe, NormalizePipe],
    templateUrl: './org-hat-dialog.html',
    styleUrls: ['./org-hat-dialog.scss', '../org-dialog.scss', '../../organization-board.component.scss'],
})
export class OrgHatDialogComponent implements OnInit {
    public hatName = '';
    public securityGroups: OrgSecurityGroup[] = [];

    public snackbar = inject(MatSnackBar);
    private profileColorService = inject(ProfileColorService);

    constructor(
        public dialogRef: MatDialogRef<OrgHatDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            user?: any;
            node: ECONode<any>;
        }
    ) {}

    public ngOnInit(): void {
        console.log('Dialog data: ', this.data);

        // TODO: we'll probably need to determine what type of EcoNode is being inputted.
        // At the moment, we only have EcoNode<Position> calling this dialog.
        const node = this.data.node as ECONode<Position>;
        console.log('Node: ', node);

        if (node.data) {
            this.hatName = node.data.name;
            this.securityGroups = <any>node.data.securityGroupsArray || [];

            // Ensure profile colors are loaded for users
            const userKeys = (node.data.userDetailsArray || []).map((u: any) => u.key || u.uid).filter(Boolean);
            this.profileColorService.ensureLoadedMany(userKeys);
        }
    }

    public get userDetailArray() {
        return this.data?.node?.data?.userDetailsArray || [];
    }

    public onClickFeature(group: OrgSecurityGroup, featureClicked: string) {
        console.log('Feature clicked: ', featureClicked);
        console.log('Feature group: ', group);
        this.snackbar.open(`Feature ${featureClicked} clicked`, 'Close', { duration: 2000 });
    }

    /**
     * Gets the avatar URL for a user.
     * Returns photoThumbnail if available, otherwise falls back to generated avatar.
     */
    public getUserAvatarUrl(user: any): string {
        // Check user object for photoThumbnail
        if (user?.photoThumbnail) {
            return user.photoThumbnail;
        }

        // Fall back to generated avatar using profile color
        const name = user?.name || 'User';
        const uid = user?.key || user?.uid || '';
        return this.profileColorService.getAvatarUrl(uid, name, 40);
    }
}
